class SearchController {

	/**
	 * method used to toggle on or off the search bar based on class
	 * @param {Node} headerSearch
	 * @param {Node} searchButton
	 */
	static toggleSearch(headerSearch, searchButton) {
		if (headerSearch.classList.contains('desktop-show')) {
			SearchController.closeSearch(headerSearch, searchButton);
		} else {
			SearchController.openSearch(headerSearch, searchButton);
		}
	}

	/**
	 * Closes the search bar and sets appropriate a11y values
	 * @param {Node} headerSearch
	 * @param {Node} searchButton
	 */
	static closeSearch(headerSearch, searchButton) {
		headerSearch.classList.remove('desktop-show');
		headerSearch.setAttribute('aria-hidden', 'true');
		searchButton.setAttribute('aria-expanded', 'false');
		SearchController.headerSearchBar.value = "";
		SearchController.headerSearchSubmit.disabled = true;

		SearchController.headerSearchBar.tabIndex = "-1";

		document.removeEventListener('click', function(e) {
			SearchController.offClickCloseSearch(e, headerSearch, searchButton);
		});

		document.removeEventListener('keydown', function(e) {
			SearchController.escapeKeyCloseSearch(e, headerSearch, searchButton);
		});
	}

	/**
	 * Opens search bar and sets appropriate a11y values
	 * @param {Node} headerSearch
	 * @param {Node} searchButton
	 */
	static openSearch(headerSearch, searchButton) {
		headerSearch.classList.add('desktop-show');
		headerSearch.removeAttribute('aria-hidden');
		searchButton.setAttribute('aria-expanded', 'true');

		SearchController.headerSearchBar.tabIndex = "0";
		SearchController.headerSearchBar.focus();

		document.addEventListener('click', function(e) {
			SearchController.offClickCloseSearch(e, headerSearch, searchButton);
		});

		document.addEventListener('keydown', function(e) {
			SearchController.escapeKeyCloseSearch(e, headerSearch, searchButton);
		});
	}

	/**
	 * Handles closing search if mouse clicks on target outside of it.
	 * @param {MouseEvent} e
	 * @param {Node} headerSearch
	 * @param {Node} searchButton
	 */
	static offClickCloseSearch(e, headerSearch, searchButton) {
		if (!e.target.classList.contains('search-toggle') && e.target.closest('.search-ui') === null) {
			SearchController.closeSearch(headerSearch, searchButton);
		}
	}

	/**
	 * Handles escape key close event when search bar is open.
	 * @param {KeyEvent} e
	 * @param {Node} headerSearch
	 * @param {Node} searchButton
	 */
	static escapeKeyCloseSearch(e, headerSearch, searchButton) {
		var key = e.key || e.which || e.keyCode || 0;
		var escKey = 27;
		var escString = 'Escape';
		var ie11EscString = 'Esc';

		if (key === escString || key === ie11EscString || key === escKey) {
			SearchController.closeSearch(headerSearch, searchButton);
		}
	}

	/**
	 * Updates redirect button based on value of the search's input
	 * @param {String} queryString
	 * @param {Node} anchorLink
	 */
	static updateButtonStatus(queryString, button) {
		if (queryString === '' || queryString.trim() === '') {
			button.disabled = true;
		} else {
			button.disabled = false;
		}
	}

	/**
	 * Update attributes based on screen width, aria hidden always removed on mobile.
	 * @param {Node} headerSearch
	 */
	static updateAttributes(headerSearch, headerSearchBar) {
		const largeBreakpoint = 992;

		if (window.innerWidth < largeBreakpoint || headerSearch.classList.contains('desktop-show')) {
			headerSearch.removeAttribute('aria-hidden');
			headerSearchBar.tabIndex = "0";
		} else {
			headerSearch.setAttribute('aria-hidden', 'true');
			headerSearchBar.tabIndex = "-1";
		}
	}

	/**
	 * @return toggle search button
	 */
	static get searchButton() {
		return document.querySelector('header .search-toggle');
	}

	/**
	 * @return header search container
	 */
	static get headerSearch() {
		return document.querySelector('header nav .search-ui');
	}

	/**
	 * @return input element within header search container
	 */
	static get headerSearchBar() {
		return document.querySelector('header nav .search-ui input');
	}

	/**
	 * @return button used to submit the search query
	 */
	static get headerSearchSubmit() {
		return document.querySelector('header nav .search-ui [type="submit"]');
	}

	/**
	 * @return a string representing the toggle search button markup
	 */
	static get searchButtonMarkup() {
		return '<button class="btn search-toggle" type="button" aria-expanded="false" aria-controls="headerSearchContainer" aria-label="Search SNHU"><span class="icon icon-magnifier--white"></span><span class="icon closer"></span></button>';
	}

	/**
	 * @return container used to hold search toggle button
	 */
	static get searchButtonContainer() {
		return document.querySelector('header .search-toggle-container');
	}
}

// export as a module for unit testing
if (typeof exports !== 'undefined') {
	module.exports = SearchController;
}

// Initialize and run in IIFE
(function() {
	window.addEventListener('load', function() {
		let headerSearch = SearchController.headerSearch;
		let searchButtonContainer = SearchController.searchButtonContainer;

		// Check to see if the search bar even exists
		if (headerSearch !== null && searchButtonContainer !== null) {

			// Adds search toggle button to nav if search bar exists
			searchButtonContainer.insertAdjacentHTML('afterbegin', SearchController.searchButtonMarkup);

			let searchButton = SearchController.searchButton;
			let headerSearchBar = SearchController.headerSearchBar;
			let headerSearchSubmit = SearchController.headerSearchSubmit;

			// Run attribute update to see if screen width is mobile
			SearchController.updateAttributes(headerSearch, headerSearchBar);

			window.addEventListener('resize', function() {
				SearchController.updateAttributes(headerSearch, headerSearchBar);
			});

			searchButton.addEventListener('click', function() {
				SearchController.toggleSearch(headerSearch, searchButton);
			});

			searchButton.addEventListener('keydown', function(e) {
				var key = e.key || e.which || e.keyCode || 0;
				var enterKey = 13;
				var spaceKey = 32;
				if (key === enterKey || key === spaceKey) {
					SearchController.toggleSearch(headerSearch, this);
				}
			});

			headerSearchBar.addEventListener('input', function() {
				SearchController.updateButtonStatus(headerSearchBar.value, headerSearchSubmit);
			});

			headerSearchBar.addEventListener('keydown', function(e) {
				var enterKey = 13;
				if (e.key === 'Enter' || e.keyCode === enterKey || e.which === enterKey) {
					e.preventDefault();
					headerSearchSubmit.click();
				}
			});
		}
	});
}());